<template>
	<div>
		<el-row>
			<el-button
				size="small"
				class="pull-right"
				type="primary"
				@click="handleSearch"
			>搜索</el-button
			>
			<el-col class="pull-right" style="width: 200px; margin-right: 20px;">
				<el-input
					size="small"
					v-model="params.name"
					placeholder="等级名称"
				></el-input>
			</el-col>
		</el-row>
		<el-table v-loading="loading" :data="dataList">
			<el-table-column prop="id" label="ID" width="240px"></el-table-column>
			<el-table-column prop="name" label="名称"></el-table-column>
			<el-table-column prop="title" label="标题"></el-table-column>
			<el-table-column prop="dan" label="段位"></el-table-column>
			<el-table-column prop="score" label="升级所需积分"></el-table-column>
			<el-table-column prop="sort" label="排序"></el-table-column>
			<el-table-column label="操作" width="180">
				<template slot-scope="{ row }">
					<el-button type="primary" size="small" @click="handleChange(row)"
					>编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<el-pagination
			background
			:page-size="dataMeta.per_page || 15"
			:total="dataMeta.total || 0"
			:current-page="page"
			@current-change="handlePageChange"
		></el-pagination>
		<el-dialog
			:visible="visibleChange"
			title="修改规则"
			@close="visibleChange = false"
			width="400px"
			:close-on-click-modal="false"
		>
			<el-form :model="formData" label-width="80px">
				<el-form-item prop="name" label="名称">
					<el-input size="small" type="number" v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item prop="title" label="标题">
					<el-input size="small"  v-model="formData.title"></el-input>
				</el-form-item>
				<el-form-item prop="dan" label="段位">
					<el-input size="small"  v-model="formData.dan"></el-input>
				</el-form-item>
				<el-form-item prop="score" label="所需积分">
					<el-input size="small"  type="number"  v-model="formData.score"></el-input>
				</el-form-item>
				<el-form-item prop="sort" label="排序">
					<el-input size="small"  type="number"  v-model="formData.sort"></el-input>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleChange = false">取 消</el-button>
        <el-button
					size="small"
					type="primary"
					@click="change"
					:loading="buttonLoading"
				>确 定</el-button
				>
      </span>
		</el-dialog>
	</div>
</template>

<script>
	import { getData, patchData } from '../../http'
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				loading: false,
				params: {
					name: '',
					page: 1
				},
				formData: {
					name: undefined,
					dan: undefined,
					title: '',
					score: 1,
					sort: 1
				},
				visibleChange: false,
				editInfo: undefined,
				buttonLoading: false,
				dataList: undefined,
				dataMeta: {},
				page: 1
			}
		},
		computed: {
			...mapState({
				listData: state => state.data.userScoreRules.data,
				listMeta: state => state.data.userScoreRules.meta
			})
		},
		watch: {
			visibleChange(val) {
				if (val) {
					const {
						name,
						dan,
						title,
						score,
						sort
					} = this.editInfo
					this.formData = {
						name,
						dan,
						title,
						score,
						sort
					}
				}
			}
		},
		methods: {
			getTableData() {
				this.loading = true
				getData(`user_score_rules`, this.params)
					.then(res => {
						this.dataList = res.data
						this.dataMeta = res.meta
					})
					.finally(() => {
						this.loading = false
					})
			},
			handlePageChange(page) {
				this.params.page = page
				this.getTableData()
			},
			handleSearch() {
				this.params.page = 1
				this.getTableData()
			},
			handleChange(row) {
				this.visibleChange = true
				this.editInfo = row
			},
			change() {
				this.buttonLoading = true
				patchData(`user_score_rules/${this.editInfo.id}`, {
					...this.formData
				})
					.then(res => {
						this.$message.success('修改成功')
						this.visibleChange = false
						this.getTableData()
					})
					.finally(() => {
						this.buttonLoading = false
					})
			}
		},
		created() {
			this.getTableData()
		}
	}
</script>

<style>
</style>
